import { LineChart } from '@mui/x-charts';

export interface ChartData {
  date: Date;
  value: number;
}

interface UsageChartProps {
  data: ChartData[];
  yAxisValueFormatter: any;
  label: string; // y-axis label
  yKey: string;  // Key for the y-axis data
}

export default (props: UsageChartProps) => {
  const transformedDataset = props.data.map((entry) => ({
    date: entry.date.toString(), // Convert date to string
    value: entry.value,
  }));

  return (
    <LineChart
      className='usage-chart'
      dataset={transformedDataset}
      width={600}
      height={300}
      xAxis={[
        {
          scaleType: 'band',
          dataKey: 'date',
          label: 'Date',
          disableTicks: true
        },
      ]}
      yAxis={[{ dataKey: 'value', label: props.yKey }]}
      series={[{ 
        dataKey: 'value', 
        id: props.yKey, 
        color: '#08b248', 
        valueFormatter: (v) => (props.yAxisValueFormatter(v, props.yKey)
      )}]}
    />
  )
};
